import type { ConversationLogDto } from '@shared/services/conversationApiService/apiService';
import { getTranscriptSeekOffset } from './callDetail.utils';

export const getActiveTranscriptIndex = (
  messages: ConversationLogDto[],
  currentTime: number,
  callStartedAt?: string | null,
  audioDuration?: number,
): number | null => {
  if (!Number.isFinite(currentTime) || currentTime < 0) return null;

  let activeIndex: number | null = null;
  messages.forEach((message, index) => {
    const offset = getTranscriptSeekOffset(message.createdAt, callStartedAt, audioDuration);
    if (offset !== null && offset <= currentTime) activeIndex = index;
  });
  return activeIndex;
};
